<template>
    <div class="mode-button-wrapper">
        <div v-for="(option, index) in options" :key="`mode-button-option-${index}`"
            :class="{'selected': isSelected(option)}"
            class="mode-button clickable" 
            @click="select(option)"
        >
            <i class="fas fa-fw" :class="option.icon_class"></i>
        </div>
    </div>
</template>

<script>
export default {
    props: ['options', 'value', 'values'],
    methods: {
        select(option) {
            this.$emit('select', option);
        },

        isSelected(option) {
            if (this.values) {
                return this.values.includes(option.value);
            } else return this.value === option.value;
        }
    }
}
</script>

<style lang="sass">
    @import "../assets/colors.sass";

    .mode-button-wrapper 
        display: flex
        flex-direction: row
        align-items: flex-end
        box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.25), -3px 1px 2px -1px rgba(0,0,0,0.15)
        border-radius: 5px
        height: 40px
        overflow: hidden
    
    .mode-button
        height: 40px
        width: 40px
        display: flex
        justify-content: center
        align-items: center
        padding: 5px 5px
        line-height: 16px
        box-sizing: border-box
        position: relative
        border: 1px solid $border-medium
        border-width: 1px 0px
        color: #7b7b7b

        &:first-child 
            border-top-left-radius: 5px
            border-bottom-left-radius: 5px

        &:last-child 
            border-top-right-radius: 5px
            border-bottom-right-radius: 5px

        &.selected
            background-color: $dark-bg
            opacity: 1
            // top: 2px
            height: 39px
            color: #ebebeb
            border-left-width: 0px !important
            border-right-width: 0px !important
            cursor: default
            // border-top: 1px solid darken($border-medium, 2%)
            // border-bottom: 1px solid darken($border-medium, 2%)
            // &:not(.selected ~ .selected, .selected + .selected)
            box-shadow: inset 3px 0px 2px -1px rgba(0,0,0,0.2), 
            inset -3px 0px 2px -1px rgba(0,0,0,0.2)
            
            &:last-child
                border-left-width: 0.5px !important
            &:first-child
                border-right-width: 0.5px !important
            &:not(:first-child)
                box-shadow: inset 3px 0px 2px -1px rgba(0,0,0,0.2)
            &:not(:last-child)
                box-shadow:  inset -3px 0px 2px -1px rgba(0,0,0,0.2)

        &.selected + .mode-button:not(.selected)
            border-left: 1px solid $border-medium

        &:hover:not(.selected)
            opacity: 1
            background-color: lighten($dark-bg, 5%) !important
            color: #ababab

        &:not(:last-child)
            border-right: 1px solid $border-medium

    .fas::before
        height: 16px
        display: inline-block
</style>